import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'default' | 'lg' | 'xl';
  fullWidth?: boolean;
  withIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'default',
  fullWidth = false,
  withIcon = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transform hover:-translate-y-0.5';
  const variants = {
    primary: 'bg-blue-900 hover:bg-blue-800 text-amber-400 shadow-lg shadow-blue-900/30 focus:ring-blue-900',
    secondary: 'bg-amber-500 hover:bg-amber-600 text-slate-900 shadow-lg shadow-amber-500/30 focus:ring-amber-500',
    outline: 'border-2 border-blue-900 text-blue-900 hover:bg-blue-50 focus:ring-blue-900'
  };
  const sizes = {
    default: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} {...props} data-id="element-276">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-277" />}
    </button>;
}